import ProductDescription from '@c/product-details/ProductDescription';
import ProductOverview from '@c/product-details/ProductOverview';
import ProductSpecs from '@c/product-details/ProductSpecs';
import { BreadcrumbItem } from '@ui/Breadcrumb';
import { ProductDocument, Variation } from 'models/product';

type ProductDescriptionTabProps = {
  product: ProductDocument;
  breadcrumbs: BreadcrumbItem[];
  selectedVariations: Variation[] | null;
};

export default function ProductDescriptionTab({
  product,
  breadcrumbs,
  selectedVariations,
}: ProductDescriptionTabProps) {
  return (
    <div className="flex flex-col gap-y-8 py-8">
      <ProductOverview product={product} breadcrumbs={breadcrumbs} />
      <div className="px-8 pt-16 sm:px-0">
        <ProductDescription product={product} />
      </div>
      <ProductSpecs product={product} selectedVariations={selectedVariations} />
    </div>
  );
}
